<template>
  <div class="main-body">
    <div class="header">老人列表</div>
    <div class="out">

      <div class="search2">

        <div style="float: right">

          <el-select v-model="governmentCode" clearable placeholder="请选择政府"
                     style="margin-right:10px">
            <el-option
                    v-for="item in governmentValue"
                    :key="item.governmentCode"
                    :label="item.name"
                    :value="item.governmentCode">
            </el-option>
          </el-select>

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 10px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-button type="primary" size="mini" plain @click="getList(true)">搜索</el-button>

        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData"
          :height="th" border v-loading="loading">

        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机"></el-table-column>
        <el-table-column prop="idCard" label="身份证"></el-table-column>
        <el-table-column prop="urgencyContact" label="紧急联系人"></el-table-column>
        <el-table-column prop="urgencyPhone" label="联系人电话"></el-table-column>

        <el-table-column prop="createTime" label="注册日期" width="180px">
          <template slot-scope="scope">
            <p>{{ scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="handleEditPwd(scope.row)">修改密码</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems /pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh'
              :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
          <el-button @click="batchDialog=false">取 消</el-button>
          <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>


    <Edit ref="myEdit" v-show="showModalEdit" v-bind:governmentValue="governmentValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    <ElderlyDetails ref="myElderlyDetails" v-show="showModalElderlyDetails" v-on:close="closeElderlyDetails" v-bind:elderlyAllType="elderlyAllType"></ElderlyDetails>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>



  </div>
</template>

<script>


import { getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import ElderlyDetails from "@/views/User/ElderlyDetails";
import elderly from "@/common/status";
import Elderly from "@/views/Elderly/Comm/ElderlyGov2";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data() {
    return {
      elderlyCode:'',
      balance:'',
      updateBalance:false,

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,


      elderlyAllType: elderly,

      governmentValue: [],
      governmentCode: '',

      elderlyType: elderly.serviceType,
      cardInsideCode: '',


      showModalElderlyDetails: false,
      showModalOldestDetails: false,
      showModalAdd: false,
      showModalEdit: false,
      roleList: null,
      editStaff: null,

      th: 0,

      batchDialog:false,
      row:null,
      password:'',


      showModalGetElderly:false,
      userCode: "",
      userName:'',

    }
  },
  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },
  components: {
    Edit, ElderlyDetails,Elderly
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init() {

      this.getGovList();

    },

    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){
                this.governmentCode = this.governmentValue[0].governmentCode;
                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },


    handleEditPwd(row){
      this.batchDialog = true;
      this.row = row
    },
    editPassword(){
      if(this.password.length<6){
        this.message.error('请输入正确格式的密码')
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'User/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode:this.row.userCode,
          password: this.password,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.batchDialog = false;
          this.$message.success('密码修改成功！')
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },









    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList() {
      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'ElderlyAdm/AdmPage',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          userCode: this.userCode,
          governmentCode: this.governmentCode
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.governmentCode);
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },


  }
}
</script>

<style lang="scss" scoped>
.userStaff /deep/ .el-form-item {
  margin-bottom: 0;
}
</style>
